import React, { useEffect } from "react";
import CustomAction from "./CustomAction/CustomAction";
import Command from "./Command/Command";
import DBLinking from "./DBLinking/DBLinking";
import CustomService from "./CustomService/CustomService";
import WebService from "./WebService/WebService";
import styles from "./Events.module.css";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";
import no_event_svg from "../../Icons/Event/no_event_svg.svg"

const EventsView = (props) => {
  const {t}=useTranslation();
  const [eventViewState, setEventViewState] = React.useState(
    props.eventViewState || {}
  );
  //  console.log("props.eventViewState", props.eventViewState);
  const [buttonstate, setButtonstate] = React.useState({
    DBLinking: true,
    Command: true,
    CustomAction: true,
   // CustomService: true,
    // CWS: true,
    CustomWebService:true,
    WebService: true,
  });

  useEffect(() => {
    Object.keys(eventViewState).forEach((key, key_index) => {
      //  console.log("key:: ", key, " key_index:: ", key_index);
    });
  }, []);

  const [renderarr, setRenderarr] = React.useState([]);
  const [openedAccordian, setopenedAccordian] = React.useState("");
  //   console.log("event state", props.eventState);
  var tempArray = [...renderarr];
  const divStyle = {
    height: "40px", 
    borderBottom: "1px solid #C4C4C4",
    boxShadow: "0px 4px 8px 0px #00000014",
    display: "flex",
    justifyContent: "end",
    alignItems: "center"
  }
  function setopenedAccordian_fn(val){
    setopenedAccordian(val);
  }

  useEffect(() => {
    // props.updation(props.control, eventViewState);
    // console.log("eventstate", eventViewState);
    Object.keys(eventViewState).forEach((subState, subStateIndex) => {
   //  console.log("creating ", subStateIndex, " :: ", subState);
      //   handleArray(subState, eventViewState[subState]);
      //  console.log("creating ", subState, " :: ", eventViewState[subState]);
      handlebutton(subState, eventViewState[subState]);
    });
  }, []);

  useEffect(()=>{
    setRenderarr((prev)=>{
      return [...prev]
    })
  },[openedAccordian]);

  useEffect(() => {
    props.updation(props.control, eventViewState);
  }, [eventViewState]);

  const handlebutton = (item, defaultState) => {
    setButtonstate((prevState) => ({
      ...prevState,
      [item]: false,
    }));

    if (item === "Command") {
      tempArray.push(
        <Command
          doneButtoncallback={props.doneButtoncallback}
          defaultState={defaultState}
          handleDelete={handledelete}
          name={item}
          elemtype={props.elemtype}
          updateHandler={updateHandler}
          openedAccordian={openedAccordian} 
          setopenedAccordian={setopenedAccordian_fn}
          control_json={props.control_json}
        ></Command>
      );
    }
    else if (item === "CustomAction") {
      tempArray.push(
        <CustomAction
          control_json={props.control_json}
          defaultState={defaultState}
          handleDelete={handledelete}
          updateHandler={updateHandler}
          name={item}
          state={eventViewState.CustomAction}
          openedAccordian={openedAccordian} 
          setopenedAccordian={setopenedAccordian_fn}
        ></CustomAction>
      );
    } 
    else if (item === "DBLinking") {
      tempArray.push(
        <DBLinking
          control_json={props.control_json}
          defaultState={defaultState}
          updateHandler={updateHandler}
          handleDelete={handledelete}
          name={item}
          openedAccordian={openedAccordian} 
          setopenedAccordian={setopenedAccordian_fn}
        ></DBLinking>
      );
    } 
    else if (item === "CustomWebService") {
      tempArray.push(
        <CustomService
        control_json={props.control_json}
          defaultState={defaultState}
          updateHandler={updateHandler}
          handleDelete={handledelete}
          name={item}
          openedAccordian={openedAccordian} 
          setopenedAccordian={setopenedAccordian_fn}
        ></CustomService>
      );
    } 
    else if (item === "WebService") {
      tempArray.push(
        <WebService
          control_json={props.control_json}
          defaultState={defaultState}
          updateHandler={updateHandler}
          handleDelete={handledelete}
          name={item}
          openedAccordian={openedAccordian} 
          setopenedAccordian={setopenedAccordian_fn}
        ></WebService>
      );
    }

    setRenderarr(tempArray);
  };

  const updateHandler = (EventName, input) => {
    //  console.log("EventName :: ", EventName, "input1 :: ", input);
    // setEventViewState({ ...eventViewState, [EventName]: input });
    setEventViewState((prevEventViewState) => {
      //  console.log("prevEventViewState :: ", prevEventViewState);
      return {
        ...prevEventViewState,
        [EventName]: input,
      };
    });
  };

  const handledelete = (entry) => {
    setRenderarr((prevState) => {
      var temp = prevState;
      for (let i = 0; i < temp.length; i++) {
        if (prevState && prevState[i].props.name === entry) {
          temp.splice(i, 1);
        }
      }
      return temp;
    });
    setButtonstate((prevstate) => ({
      ...prevstate,
      [entry]: true,
    }));

    setEventViewState((prevEventViewState) => {
      var temporary = prevEventViewState;
      delete temporary[entry];
      return temporary;
    });
  };

  return (
    <>
      <div style={divStyle}>       

        <div style={window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ?{ float: "left" }:{ float: "right" }}>
          {props.events.map((item,index) => {
            return (
              <Button
                disableFocusRipple
                disableRipple
                tabIndex={0} 
                disabled={!buttonstate[item.value]}
                className={[`${styles.controlbutton}`,`${(props?.events?.length -1) === index ? styles.marginStyle: null}`,`${index===0 ? styles.marginLeftStyle:null}`,"formBuilder-MuiButton-outlined"].join(" ")}
                onClick={() => {
                  handlebutton(item.value);
                }}
              >
                + {t(item.label)}
              </Button>
            )
          })}
        </div>
      </div>
      <div
        className={ styles.EventsViewParent }
        style={{
          display: renderarr.length===0 ? "flex" : "",
          justifyContent:  renderarr.length===0 ?  "center" :"",
          width: "100%",
          maxHeight: "95%",
          overflowY: "auto", 
          marginBottom: "50px"
        }}
      >
        {renderarr.length===0 && 
          <img src={no_event_svg} 
            style={{
              height :"288px", 
              width :"260px",
              transform: "translate(-50%, -50%)",
              position: "absolute",
              left: "50%",
              top: "50%"
            }} 
          />
        }
        {renderarr.map((item, index) => {
          console.log("renderarr", openedAccordian);
          return item;
        })}
      </div>
    </>
  );
};

export default EventsView;
